export const serializeObjectToUrlQueryParameters = (data) => {
  return Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&');
};
